import {Component, OnInit, Inject} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
    selector: 'escolher-tipo-associacao-dialog',
    templateUrl: './escolher-tipo-associacao-dialog.component.html',
    styleUrls: ['./escolher-tipo-associacao-dialog.component.css']
})
export class EscolherTipoAssociacaoDialogComponent implements OnInit {

    linhasSemContaContabil: number;
    totalLinhas: number;

    constructor(
        private dialogRef: MatDialogRef<EscolherTipoAssociacaoDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data: any
    ) {
        if (data) {
            this.linhasSemContaContabil = data.linhasSemContaContabil || 0;
            this.totalLinhas = data.totalLinhas || 0;
        }
    }

    ngOnInit(): void {
    }

    escolherSemContaContabil(): void {
        this.dialogRef.close('semContaContabil');
    }

    escolherTodas(): void {
        this.dialogRef.close('todas');
    }

    cancelar(): void {
        this.dialogRef.close(null);
    }
}
